/* @flow */
import * as React from 'react';
import onClickOutside from 'react-onclickoutside';

import styles from './styles.module.scss';
import Icon from '../Icon';

type Item = {
  text: string,
  onClick: () => mixed,
  iconName: string,
};

type Props = {
  visible: boolean,
  items: Item[],
  onClickOutside: () => mixed,
};

class MenuPopover extends React.PureComponent<Props, void> {
  handleClickOutside() {
    if (this.props.visible) {
      this.props.onClickOutside();
    }
  }

  render() {
    return (
      <div className={this.props.visible ? styles.containerEnter : styles.containerExit}>
        {this.props.items.map((item, index) => {
          return (
            <div key={`item_${item.text}_${index}`} className={styles.item} onClick={item.onClick}>
              <p>{item.text}</p>
              <Icon name={item.iconName} />
            </div>
          );
        })}
      </div>
    );
  }
}

export default onClickOutside(MenuPopover);
